import { render } from "./FadingImages.vue?vue&type=template&id=0e3c4780"
import script from "./FadingImages.vue?vue&type=script&lang=js"
export * from "./FadingImages.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\antho\\Documents\\Projects\\ynforma-website\\ynforma-website-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__